import { render, staticRenderFns } from "./StudentMaterials.vue?vue&type=template&id=42b5eeae&scoped=true&"
import script from "./StudentMaterials.vue?vue&type=script&lang=js&"
export * from "./StudentMaterials.vue?vue&type=script&lang=js&"
import style0 from "./StudentMaterials.vue?vue&type=style&index=0&id=42b5eeae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b5eeae",
  null
  
)

export default component.exports